import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import order from '@/mixins/orders'
import typePayment from '@/mixins/generals/typePayment.js'
import bookstore from '@/mixins/generals/bookstore.js'
import stringAnalysis from '@/mixins/generals/stringAnalysis.js'
import facturacionCLPrint from '@/mixins/facturacionCLPrint.js'
import productPriceList from '@/mixins/products/productPriceList.js'
import client from '@/mixins/clients'

var bookstoreBilling = {
    mixins: [axiosAction, errors, mixin, order, typePayment, facturacionCLPrint, bookstore, stringAnalysis, productPriceList, client],
    data() {
        return {
            inputPrincipal: '',
            listHistoryBookstoreBilling: [],
            loadFullBookstoreBilling: false,
            quatityProductNewItem: 1,
            showTypePaymentIdsDefaultIds: [
                { id: 1, limit: 1 },
                { id: 4, limit: false },
                { id: 5, limit: false },
                { id: 6, limit: false }
            ],
            storesAllowed: [1, 5],
            typeHistory: [
                { id: 1, name: 'Información', synthetic: 'info', class: 'fas fa-info-circle', color: 'info' },
                { id: 2, name: 'Procesando', synthetic: 'load', class: 'fas fa-spinner fa-spin', color: 'secondary' },
                { id: 3, name: 'Error', synthetic: 'danger', class: 'fas fa-times', color: 'danger' },
                { id: 4, name: 'Advertencia', synthetic: 'warning', class: 'fas fa-exclamation-triangle', color: 'warning' },
                { id: 5, name: 'Concejo', synthetic: 'council', class: 'far fa-lightbulb', color: 'white' },
            ],
        }
    },
    computed: {
        disabledInputPrincipal() {
            if (this.searchingProductPriceList == true) {
                return this.searchingProductPriceList
            }
            return false
        },
        disabledBntShowPaymentModalLocal() {
            return (this.listTypePaymentsFilter.length == 0)
        },
        lastHistory() {
            if (this.listHistoryBookstoreBilling.length == 0) {
                return null
            }
            return this.listHistoryBookstoreBilling[this.listHistoryBookstoreBilling.length - 1]
        },
        listHistoryBookstoreBillingFilter() {
            return this.listHistoryBookstoreBilling
        },
        listBookstoresFilter() {
            return this.listBookstores.filter(e => {
                return parseInt(e.status_id) == 1
            })
        },
        listTypePaymentsFilter() {
            let list = this.listTypePayments.filter(tp => {
                let index = this.showTypePaymentIdsDefaultIds.map(e => parseInt(e.id)).indexOf(parseInt(tp.id))
                return (index > -1)
            })
            return list
        },
        totalToPayment() {
            return parseInt(this.totalObjectOrderProducts) + parseInt(this.totalDiscountObjectOrderProducts)
        },
    },
    filters: {
    },
    methods: {
        addListHistoryBookstoreBilling(item) {
            item.type_history = null
            let index = this.typeHistory.map(e => parseInt(e.id)).indexOf(parseInt(item.type_history_id))
            if (index > -1) {
                item.type_history = this.typeHistory[index]
            }
            this.listHistoryBookstoreBilling.push(item)
        },
        addListPayments(item) {
            let index = this.showTypePaymentIdsDefaultIds.map(e => parseInt(e.id)).indexOf(parseInt(item.id))
            let limit = this.showTypePaymentIdsDefaultIds[index].limit
            let continue_ = false
            if (!limit) {
                continue_ = true
            } else {
                let count = 0
                index = -1
                this.objectOrder.order_payments.forEach((e, i) => {
                    if (parseInt(e.type_payment_id) == parseInt(item.id)) {
                        count++
                        index = i
                    }
                });
                if (count < limit) {
                    continue_ = true
                }
            }

            if (continue_) {
                let payment = {
                    id: 0,
                    type_payment_id: item.id,
                    typePayment: item,
                    amount: this.totalToPayment - this.totalObjectOrderPayments,
                    bank_id: 0,
                    bank: {},
                    code: '',
                    description: '',
                    transaction_date: this.currentDate(0, true),
                    status_id: 38,
                    status: {},
                }
                this.objectOrder.order_payments.push(payment)

                index = -1
                this.objectOrder.order_payments.forEach((e, i) => {
                    index = i
                });

            }
            return index
        },
        addObjectOrderProductsLocal(product) {
            let index = this.objectOrder.order_products.map(e => parseInt(e.product_id)).indexOf(parseInt(product.id))
            if (index == -1) {
                let data = {
                    id: null,
                    order_id: this.objectOrder.id,
                    product_id: product.id,
                    product: {
                        id: product.id,
                        name: product.name,
                        synthetic: product.synthetic,
                        isbn: product.isbn,
                        img: product.img,
                        group: product.group,
                        product_group: product.product_group,
                        price_list: product.price_list
                    },
                    quantity: this.quatityProductNewItem,
                    price: this.calculatePrice(this.quatityProductNewItem, product),
                    original_price: this.calculatePrice(this.quatityProductNewItem, product),
                    tax: product.tax,
                    price_list_id: this.objectPriceList.id
                }
                this.addObjectOrderProducts(data, 'up')
                this.addListHistoryBookstoreBilling({ type_history_id: 1, description: 'Se agregaron ' + data.quantity + ' ' + data.product.name, save: false, date: this.currentDate(0, true) })
                this.quatityProductNewItem = 1
            }
        },
        clearListPaymentsWith0() {
            let list = this.objectOrder.order_payments.filter(e => {
                e.amount = (isNaN(e.amount)) ? e.amount : e.amount.toString().trim()
                return !(parseInt(e.amount) <= 0 || isNaN(e.amount) || e.amount == '')
            })
            this.objectOrder.order_payments = list
        },
        deleteItemObjectOrderProductLocal(orderProduct, index) {
            this.deleteItemObjectOrderProduct(index)
            this.addListHistoryBookstoreBilling({ type_history_id: 1, description: orderProduct.product.name + ' se quito de la lista', save: false, date: this.currentDate(0, true) })
        },
        errorHttpHandlingLocal(error) {
            this.addListHistoryBookstoreBilling({ type_history_id: 3, description: error, save: false, date: this.currentDate(0, true) })
        },

        //** Cargas Iniciales */
        getAllBookstoreByUserLoginLocal() {
            this.addListHistoryBookstoreBilling({ type_history_id: 2, description: 'Buscando Librerias Asignadas . . .', save: false, date: this.currentDate(0, true) })
            this.getAllBookstoreByUserLogin()
        },
        getAllBookstoreByUserLoginResultLocal(response) {
            if (response.data.success == true) {
                this.addListHistoryBookstoreBilling({ type_history_id: 1, description: 'Se encontraron ' + this.listBookstores.length + ' Librerias', save: false, date: this.currentDate(0, true) })
                this.configBookstoreBillingLocal()
            }
        },
        configBookstoreBillingLocal() {
            if (this.listBookstores.length == 0) {
                this.addListHistoryBookstoreBilling({ type_history_id: 3, description: 'No tiene ninguna librería asignada', save: false, date: this.currentDate(0, true) })
            } else if (this.listBookstores.length == 1) {
                this.setStoreBookstoreBilling(this.listBookstores[0])
                this.getAllTypePaymentsLocal()
            } else if (this.listBookstores.length > 1) {
                let bookstoreBillingIdDefault = localStorage.getItem('bookstoreBillingIdDefault')
                if (bookstoreBillingIdDefault != null) {
                    let index = this.listBookstores.map(e => parseInt(e.id)).indexOf(parseInt(bookstoreBillingIdDefault))
                    if (index > -1) {
                        this.setStoreBookstoreBilling(this.listBookstores[index])
                        this.getAllTypePaymentsLocal()
                    } else {
                        bookstoreBillingIdDefault = null
                    }
                }
                if (bookstoreBillingIdDefault == null) {
                    this.$refs.btnShowSelectBookstoreModal.click()
                    this.addListHistoryBookstoreBilling({ type_history_id: 4, description: 'Hay que seleccionar una Librería', save: false, date: this.currentDate(0, true) })
                }
            }
        },
        getAllTypePaymentsLocal() {
            this.addListHistoryBookstoreBilling({ type_history_id: 2, description: 'Buscando formas de Pago . . .', save: false, date: this.currentDate(0, true) })
            this.getAllTypePayments()
        },
        getAllTypePaymentsResultLocal(response) {
            if (response.data.success == true) {
                this.addListHistoryBookstoreBilling({ type_history_id: 1, description: 'Se encontraron ' + this.listTypePayments.length + ' formas de pago', save: false, date: this.currentDate(0, true) })
                this.finishedLoadLocal()
                this.reportGenesysLocal()
            }
        },
        finishedLoadLocal() {
            this.loadingConfigurations = false
            this.finishedLoadLocalBookstore()
        },
        reportGenesysLocal() {
            this.addListHistoryBookstoreBilling({ type_history_id: 2, description: 'Determinando si se reporta a Genesys . . .', save: false, date: this.currentDate(0, true) })
            this.reportGenesys()
        },
        reportGenesysResultLocal(response) {
            if (response.data.success == true) {
                let msg = (this.needGenesys) ? 'Se debe reportar a Genesys' : 'No se debe reportar a genesys'
                this.addListHistoryBookstoreBilling({ type_history_id: 1, description: msg, save: false, date: this.currentDate(0, true) })
            }
        },
        /* fin de cargas iniciales*/

        getClientForNumberDocumentLocal(documentNumber) {
            this.addListHistoryBookstoreBilling({ type_history_id: 2, description: 'Buscando al cliente con el RUT ' + documentNumber, save: false, date: this.currentDate(0, true) })
            this.getClientForNumberDocument(documentNumber)
        },
        getClientForNumberDocumentResultLocal(response) {
            if (response.data.success == true) {
                this.addListHistoryBookstoreBilling({ type_history_id: 1, description: 'Se encontró a ' + this.objectClient.name + ' ' + this.objectClient.surname, save: false, date: this.currentDate(0, true) })
            } else {
                this.addListHistoryBookstoreBilling({ type_history_id: 4, description: response.data.data, save: false, date: this.currentDate(0, true) })
                if (response.data.message == 'ECCSDN1') {
                    if (confirm(response.data.data + '.\n¿Desea registrarlo?')) {
                        this.newClientBookstoreBillingModule()
                    }
                }
            }
        },
        newClientBookstoreBillingModule() {
        },
        getProductPriceListForBookstoreBillingLocal(priceListId, type, search) {
            let continue_ = true
            let index = -1
            let quantity = 0
            if (type == 'ISBN' || type == 'SKU') {
                index = this.objectOrder.order_products.map(e => String(e.product_id)).indexOf(String(search))
                if (index == -1) {
                    index = this.objectOrder.order_products.map(e => String(e.product.isbn)).indexOf(String(search))
                }
                if (index > -1) {
                    quantity = parseInt(this.objectOrder.order_products[index].quantity) + parseInt(this.quatityProductNewItem)
                    if (quantity <= 0) {
                        this.deleteItemObjectOrderProductLocal(this.objectOrder.order_products[index], index)
                    } else {
                        let pruduct = this.objectOrder.order_products[index].product.name
                        this.objectOrder.order_products[index].quantity = quantity
                        this.objectOrder.order_products[index].price = this.calculatePrice(quantity, this.objectOrder.order_products[index].product)
                        this.addListHistoryBookstoreBilling({ type_history_id: 1, description: pruduct + ' actualizado a ' + quantity, save: false, date: this.currentDate(0, true) })
                    }
                    continue_ = false
                    this.quatityProductNewItem = 1
                }
            }
            if (continue_) {
                this.getProductPriceListForBookstoreBilling(priceListId, type, search)
            }
        },
        getProductPriceListForBookstoreBillingResultLocal(response) {
            if (response.data.success == true) {
                if (response.data.message == 'CHARACTER') {
                    this.addListHistoryBookstoreBilling({ type_history_id: 1, description: 'Se encontraron ' + this.listProductsPriceList.length + ' coincidencias', save: false, date: this.currentDate(0, true) })
                } else {
                    if (this.listProductsPriceList.length == 1) {
                        if (this.listProductsPriceList[0].price_list.length == 0) {
                            this.addListHistoryBookstoreBilling({ type_history_id: 4, description: 'El producto "' + this.listProductsPriceList[0].name + '" no tiene precio en la lista de precios ' + this.objectPriceList.name, save: false, date: this.currentDate(0, true) })
                        } else {
                            this.addObjectOrderProductsLocal(this.listProductsPriceList[0])
                            setTimeout(() => { this.$refs.inputPrincipal.focus() }, 100)
                        }
                    } else {
                        this.addListHistoryBookstoreBilling({ type_history_id: 4, description: 'Se encontraron ' + this.listProductsPriceList.length + ' con el mismo ' + type, save: false, date: this.currentDate(0, true) })
                    }
                }
            } else {
                this.addListHistoryBookstoreBilling({ type_history_id: 4, description: response.data.data, save: false, date: this.currentDate(0, true) })
                this.goToInputPrincipal()
            }
        },
        goToInputPrincipal() {
            setTimeout(() => { this.$refs.inputPrincipal.focus() }, 100)
        },
        goToInputPrincipalKeydownCtrl(e) {
            console.log(e)
        },
        initModuleLocal() {
            this.initModuleBookstore()
            this.getAllBookstoreByUserLoginLocal()
        },
        removeListPayments(index) {
            let orderPayment = this.objectOrder.order_payments.splice(index, 1)
        },
        resultAxiosLocal(responseLocal, response) {
            this.$emit('hideLockScreen')
            switch (responseLocal) {
                case 'getClientForNumberDocumentResult': this.getClientForNumberDocumentResult(response); break;
                case 'getAllBookstoreByUserLoginResult': this.getAllBookstoreByUserLoginResult(response); break;
                case 'getAllTypePaymentsResult': this.getAllTypePaymentsResult(response); break;
                case 'getAllStoresResult': this.getAllStoresResult(response); break;
                case 'getProductPriceListForBookstoreBillingResult': this.getProductPriceListForBookstoreBillingResult(response); break;
                case 'reportGenesysResult': this.reportGenesysResult(response); break;
                default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
            }
        },
        saveClientLocal(data) {
            if (data.success == true) {
                this.setObjectClient(data.data)
                if (data.message == 'ACTUALIZADO') {
                    this.addListHistoryBookstoreBilling({ type_history_id: 1, description: 'Se han actualizado los datos de ' + this.objectClient.name + ' ' + this.objectClient.surname, save: false, date: this.currentDate(0, true) })
                } else if (data.message == 'NUEVO') {
                    this.addListHistoryBookstoreBilling({ type_history_id: 1, description: 'Se han acregado al cliente ' + this.objectClient.name + ' ' + this.objectClient.surname, save: false, date: this.currentDate(0, true) })
                }
            }
            this.saveClientModal(data)
        },
        saveClientModal(data) {

        },
        searchSomething() {
            if (this.inputPrincipal.trim().length > 0) {
                let type = this.determineDataType(this.inputPrincipal)
                switch (type.result) {
                    case 'INTEGER':
                        this.quatityProductNewItem = parseInt(type.original)
                        this.addListHistoryBookstoreBilling({ type_history_id: 1, description: 'Se establecio la cantidad a ' + this.quatityProductNewItem, save: false, date: this.currentDate(0, true) })
                        this.inputPrincipal = ''
                        break
                    case 'SKU':
                    case 'ISBN':
                        this.addListHistoryBookstoreBilling({ type_history_id: 2, description: 'Buscando articulo con el ' + type.result + ' ' + type.original + ' . . .', save: false, date: this.currentDate(0, true) })
                        this.inputPrincipal = ''
                        this.getProductPriceListForBookstoreBillingLocal(this.objectPriceList.id, type.result, type.data)
                        break
                    case 'RUT':
                        this.inputPrincipal = ''
                        this.getClientForNumberDocumentLocal(type.data)
                        break
                    case 'CHARACTER':
                        this.addListHistoryBookstoreBilling({ type_history_id: 2, description: 'Buscando articulo que coincidan con ' + type.original + ' . . .', save: false, date: this.currentDate(0, true) })
                        this.inputPrincipal = ''
                        this.getProductPriceListForBookstoreBillingLocal(this.objectPriceList.id, type.result, type.original)
                        break
                    default:
                        break
                }
            } else {
                this.addListHistoryBookstoreBilling({ type_history_id: 3, description: 'Tiene que escribir algo por lo menos', save: false, date: this.currentDate(0, true) })
            }
        },
        selectPrinterInvoiceLocal(index = -1) {
            if (index == -1) {
                if (this.successFullConnectionFacturacionCLPrint) {
                    this.selectPrinterInvoiceLocalFrontend()
                } else {
                    this.connectFacturacionCLPrint()
                    this.addListHistoryBookstoreBilling({ type_history_id: 2, description: 'Estableciendo conección con WebSocket de FacturacionCL', save: false, date: this.currentDate(0, true) })
                }
            } else {
                this.indexSelectedPrinterFacturacionCLPrint = index
                this.changeSelectedPrinterFacturacionCLPrint()
            }
        },
        setObjectPriceListLocal(priceList) {
            this.setObjectPriceList(priceList)
            this.objectOrder.price_list_id = priceList.id
        },
        setStoreBookstoreBilling(item) {
            this.setObjectBookstore(item)
            this.setObjectClient(item.client)
            this.setObjectPriceListLocal(item.price_list)
            localStorage.setItem('bookstoreBillingIdDefault', item.id)
        },
        showFormClientLocal() {
            this.showFormClientModel()
        },
        showFormClientModel() { },
        socketFacturacionCLOpenLocal() {
            this.addListHistoryBookstoreBilling({ type_history_id: 1, description: 'WebSocket Fecturacion CL conectado!!!', save: false, date: this.currentDate(0, true) })
        },
        socketFacturacionCLCloseLocal() {
            this.addListHistoryBookstoreBilling({ type_history_id: 3, description: 'Conexion WebSocket Facturacion CL cerrada', save: false, date: this.currentDate(0, true) })
        }
    },
};

export default bookstoreBilling;